<template>
  <div class="organization-edition-form">
    <v-alert
      v-model="alert"
      dismissible
      color="error"
      border="left"
      elevation="2"
      colored-border
      icon="priority_high"
    >An error happened while saving: {{errorDisplay(updateError)}}</v-alert>
    <v-row no-gutters>
      <v-btn class="my-4 mx-1" :color="editable ? 'error': 'primary'" @click="cancelEdition">
        <v-icon dark left>{{editable ? 'cancel' : 'mdi-pencil'}}</v-icon>
        {{ editable ? 'Cancel' : 'Edit' }}
      </v-btn>
      <v-btn
        class="my-4 mx-1"
        color="success"
        v-if="editable"
        :loading="updateLoading"
        @click="save"
      >
        <v-icon dark left>save</v-icon>Save
      </v-btn>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" md="6">
        <v-text-field
          label="uuid"
          placeholder="uuid"
          outlined
          dense
          v-model="uuid"
          disabled
          class="pa-1"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          label="name*"
          placeholder="Name..."
          outlined
          v-model="newName"
          :rules="[rules.min3]"
          required
          dense
          :disabled="!editable"
          class="pa-1"
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import mixin from "@/mixins";
export default {
  mixins: [mixin],
  props: {
    uuid: { type: String, required: true },
    name: { type: String, required: true }
  },
  data() {
    return {
      alert: false,
      editable: false,
      newName: "",
      rules: {
        min3: v =>
          v.length >= 3 ||
          "This field is required, and must contain 3 letters at least"
      }
    };
  },
  computed: {
    ...mapState({
      updateError: state => state.organizations.updateOne.error,
      updateLoading: state => state.organizations.updateOne.pending
    })
  },
  watch: {
    name() {
      this.newName = this.name;
    }
  },
  methods: {
    cancelEdition() {
      if (this.editable) {
        this.newName = this.name;
      }
      this.editable = !this.editable;
    },
    save() {
      this.$emit("save", this.newName);
    },
    saveCallback() {
      this.editable = false;
    }
  }
};
</script>
